import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalDataService } from '../../../../services/global-data.service';
import { OperationService } from '../operation.service';

export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-operation',
  templateUrl: './operation.component.html',
  styleUrls: ['./operation.component.css'],
  providers: [OperationService]
})
export class OperationComponent implements OnInit {

  operation: any = [];
  operationCart: any = [];
  operationCartServer: any = [];
  operationCartServerloading: boolean = false;
  loading: boolean = false;

  operationItemModal: boolean = false;
  loadingOperationItem: boolean = false;
  operationItems: any = [];

  messageDisplay: boolean = false;
  deleteIndex: any;

  title: string = "Заявки";
  store_id: string = "";

  pagination: Pagination;


  searchColumn: any = [];
  searchFilter: any = [];
  statusList: any = [];



  constructor(
    private operationService: OperationService,
    public global: GlobalDataService,
    private router: Router) { }

  ngOnInit() {

    this.fillSearchColumn();
    this.init();
    this.pagination = {
      current_page: 1,
      per_page: 1,
      last_page: 1
    }
    this.onLoad();
    this.loadOperationServerByFilter();
  }


  create(): void {
    // this.operationService.createOperationInvoice(this.geterateInvoiceNumber()).subscribe(response=>{this.open(response['data'].id);});
  }

  loadOperationServerByFilter(filter=[],page: number = 1) {
    this.operationCartServerloading = true;
    this.operationService.getOperationByFilter(filter,page).subscribe(response => { this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1}; this.operationCartServer = response['data'], this.operationCartServerloading = false; });
  }

  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Номер", value: { column: "invoice_number", type: "textbox" } });
    this.searchColumn.push({ label: "Статус", value: { column: "status_id", type: "dropdown" , value:  this.statusList} });
    this.searchColumn.push({ label: "Дата начала", value: { column: "date_start", type: "calendar"} });
    this.searchColumn.push({ label: "Дата конца", value: { column: "date_finish", type: "calendar"} });
    this.searchColumn.push({ label: "Склад", value: { column: "from_store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }
  init(){
    this.statusList.push({ label: 'Завершен', value: { value: 4, label: 'Завершен' }});
    this.statusList.push({ label: 'Принят', value: { value: 3, label: 'Принят' }});
    this.statusList.push({ label: 'На рассмотрении', value: { value: 2, label: 'На рассмотрении' }});
    this.statusList.push({ label: 'Отменен', value: { value: -1, label: 'Отменен' }});
    this.fillSearchColumn();
  }

  setFilter(data){
    this.searchFilter=data;
    this.loadOperationServerByFilter(this.searchFilter, 1);
  }

  onLoad() {
    this.loading = true;
    if (localStorage.getItem('operations')) {
      this.operationCart = JSON.parse(localStorage.getItem('operations'));
      this.operationCart = this.operationCart.map((value, index) => { value.index = index; return value; });
    }
    this.loading = false;
  }

  onPaginate(event) {
    event.page = event.page + 1
    this.pagination.current_page=event.page;
    this.loadOperationServerByFilter(this.searchFilter,event.page);
  }

  getTest(){
    return "#a5a4a4";
  }
  getColor(statusId: any) {
    switch (+statusId) {
      case 0:
        return "#a5a4a4";
      case 2:
        return "orange";  
      case 3:
        return "#2185d0";
      case 4:
        return "#26ea53";
      case -1:
        return "rgb(253, 61, 61)";
    }
  }

  delete(index: any): void {
    this.messageDisplay = true;
    this.deleteIndex = index;
  }

  OnAgreeDelete() {
    this.operationCart.splice(this.deleteIndex, 1);
    this.deleteIndex = null;
    this.messageDisplay = false;
    this.save();
    this.onLoad();
  }

  OnDegreeDelete() {
    this.messageDisplay = false;
  }

  // onCancelOperation() {
  //   this.operationService.cancelOperation({ id: this.operation.id }).subscribe(response => {this.operationItemModal=false; this.loadOperationServerByFilter(this.searchFilter,this.pagination.current_page);});
  // }

  showOperationListItem(operation: any){
    this.router.navigate(['/dashboard/operation-list-item', operation.id]);
  }

  getOperationById(operation: any) {
    console.log(operation);
    this.operation = operation;
    // this.saleItemId=this.sale.id;
    this.operationItems = [];
    this.operationItemModal = true;
    this.loadingOperationItem = true;
    this.operationService.getOperationItemsById(this.operation.id).subscribe(response => {
      this.operationItems = response['data'];
      this.loadingOperationItem = false;
    })
  }
  // OnMoveToSale() {
  //   this.router.navigate(['/dashboard/sale-update/', { contractor_id: this.operation.created_by.contractor_id, from_type: "operation", id: this.operation.id }])
  // }
  open(index: any): void {
    this.router.navigate(['/dashboard/operation-items', index]);
  }

  save() {
    localStorage.setItem('operations', JSON.stringify(this.operationCart));
  }

  add(): void {
    this.operationCart.push({
      index: this.operationCart.length,
      invoice_number: (+this.operationCart.length > 0 ? this.operationCart[this.operationCart.length - 1].invoice_number + 1 : 1),
      operation_type_id: 1,
      sum_total: 0,
      status: { name: "Новая" },
      created_at: new Date().toISOString().slice(0, 10),
      created_by: { id: this.global['user']['id'], full_name: this.global['user']['contact']['full_name'] },
      items: []
    });
    this.save();
    this.router.navigate(['/dashboard/operation-items', this.operationCart.length - 1]);
  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/operations/operation/operation.component.ts